var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 90H42V96H105V90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.885 18.2176L13.8845 54.2152L16.1127 59.7861L106.113 23.7885L103.885 18.2176Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69H48V75H96V69Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 60H54V66H90.17V60Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0459 62.5195L78.123 63.4788L81.0385 81.4792L86.9613 80.5199L84.0459 62.5195Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1239 62.489L57.0406 80.4894L62.9544 81.5024L66.0377 63.502L60.1239 62.489Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 70.8C25.1725 70.8 21 66.6275 21 61.5C21 56.3725 25.1725 52.2 30.3 52.2C35.4275 52.2 39.6 56.3725 39.6 61.5C39.6 66.6275 35.4275 70.8 30.3 70.8ZM30.3 58.2C28.48 58.2 27 59.68 27 61.5C27 63.32 28.48 64.8 30.3 64.8C32.12 64.8 33.6 63.32 33.6 61.5C33.6 59.68 32.12 58.2 30.3 58.2Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 83.4C25.1725 83.4 21 79.2275 21 74.1C21 68.9725 25.1725 64.8 30.3 64.8C35.4275 64.8 39.6 68.9725 39.6 74.1C39.6 79.2275 35.4275 83.4 30.3 83.4ZM30.3 70.8C28.48 70.8 27 72.28 27 74.1C27 75.92 28.48 77.4 30.3 77.4C32.12 77.4 33.6 75.92 33.6 74.1C33.6 72.28 32.12 70.8 30.3 70.8Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 96C25.1725 96 21 91.8275 21 86.7C21 81.5725 25.1725 77.4 30.3 77.4C35.4275 77.4 39.6 81.5725 39.6 86.7C39.6 91.8275 35.4275 96 30.3 96ZM30.3 83.4C28.48 83.4 27 84.88 27 86.7C27 88.52 28.48 90 30.3 90C32.12 90 33.6 88.52 33.6 86.7C33.6 84.88 32.12 83.4 30.3 83.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoof);
export default __webpack_public_path__ + "static/media/Roof.3384bbe3.svg";
export { ForwardRef as ReactComponent };